export default __webpack_public_path__ + "static/media/CartaoValeTransporte.d979ac3b.svg";